/* global SyntaxHighlighter, _, $, JST */
import React from 'react'

type Props = {
  model: Object,
  path: string,
  language: string,
  source: string,
  lineHeight?: number,
  ranged: Array<Object>
}

export default class CodeView extends React.Component<Props> {
  render () {
    return (
      <div id='c  ode-container'>
        <div className='flags-content' />
        <div className='report-class-header-table'>
          {this.props.path}
        </div>
        <code>
          <pre className={`brush: ${this.props.language};`}>
            {this.props.source}
          </pre>
        </code>
      </div>
    )
  }

  componentDidMount () {
    return this.setSyntaxHighlighterAttrs()
  }

  setSyntaxHighlighterAttrs () {
    SyntaxHighlighter.defaults['quick-code'] = false
    SyntaxHighlighter.defaults.toolbar = false
    SyntaxHighlighter.highlight()
    const result = this.getRangeOfIssues(this.props.model)
    return this.setHeaderIssue(result.startLinesHash, result.startLinesLength)
  }

  setHeaderIssue (startLinesHash, startLinesLength) {
    return _.each(startLinesHash, (issues, startLine) => {
      const containerRow = $('.container').find(`.number${parseInt(startLine)}`)
      const gutterRow = $('.gutter').find(`.number${parseInt(startLine)}`)
      this.addHeadersToIssues(containerRow, gutterRow, this.props.lineHeight)
      const breakLines = this.getBreakLinesCount(startLinesHash, startLine)
      const topValue = 38 +
                (this.props.lineHeight * parseInt(startLine)) +
                (this.props.lineHeight * (breakLines - 1))
      const htmlContent = this.getHtmlFor(issues)
      const html = `<div class='flag-content' \
style='top: ${topValue}px;'>${htmlContent}</div>`
      // TODO: GET RID OF jQuery
      return $('.flags-content').append(html)
    })
  }

  addHeadersToIssues (containerRow, gutterRow, lineHeight) {
    gutterRow.css({'margin-top': `${lineHeight}px`})
    containerRow.css({'margin-top': `${lineHeight}px`})
    containerRow.append('<div class="highlight-break-line"></div>')
    return gutterRow.append('<div class="gutter-break-line"></div>')
  }

  getBreakLinesCount (startLinesHash, startLine) {
    let breaklines = 0
    _.each(startLinesHash, function (issues1, startLine1) {
      if (parseInt(startLine) > parseInt(startLine1)) {
        breaklines += 1
      }
    })
    return breaklines
  }

  getHtmlFor (issues) {
    return _.map(issues, (key, index) => {
      const issueDetails = this.getIssueDetails(key)
      return JST['templates/report_classes/line_issues']({
        key,
        index,
        issueName: issueDetails.name,
        link: issueDetails.link
      })
    }).join()
  }

  getRangeOfIssues (model) {
    const result = this.startLineObjects(model)
    return {
      startLinesHash: result.startLinesHash,
      startLinesLength: result.startLinesLength
    }
  }

  startLineObjects (startLinesLength = 0, startLinesHash = {}) {
    this.props.ranged.map(object => {
      startLinesLength += 1
      startLinesHash = this.addObject(startLinesHash, object.start_line, object.key)
      return this.addHighlightClass(object)
    })
    return {startLinesLength, startLinesHash}
  }

  addHighlightClass (object) {
    return (() => {
      const result = []
      for (let i = parseInt(object.start_line), end = parseInt(object.end_line); i <= end; i++) {
        result.push($('.container').find(`.number${i}`)
          .append('<div class="codebeat-highlight"></div>'))
      }
      return result
    })()
  }

  addObject (startLinesHash, startLine, key) {
    if (startLinesHash[`${startLine}`]) {
      startLinesHash[`${startLine}`].push(key)
    } else {
      startLinesHash[`${startLine}`] = [key]
    }
    return startLinesHash
  }

  getIssueDetails (issueKey) {
    const rootUrl = 'https://hub.codebeat.co/v1.0/docs/software-quality-metrics#'
    const issueNameMap = {
      'ABC': {
        name: 'Assignment Branch Condition',
        link: `${rootUrl}section-assignment-branch-condition`
      },
      'AR': {
        name: 'Too many arguments',
        link: `${rootUrl}section-arity`
      },
      'BN': {
        name: 'Block nesting',
        link: `${rootUrl}section-maximum-block-nesting`
      },
      'CC': {
        name: 'Cyclomatic complexity',
        link: `${rootUrl}section-cyclomatic-complexity`
      },
      'LOC': {
        name: 'Lines of code',
        link: `${rootUrl}section-lines-of-code`
      },
      'IC': {
        name: 'Identical code',
        link: `${rootUrl}section-code-duplication`
      },
      'RA': {
        name: 'Too many return values',
        link: `${rootUrl}section-number-of-return-values-go-only`
      },
      'SC': {
        name: 'Similar code',
        link: `${rootUrl}section-code-duplication`
      }
    }
    return issueNameMap[issueKey] || 'Unknown symbol'
  }
};

CodeView.defaultProps = {
  lineHeight: 19
}

window.Components.CodeView = React.createFactory(CodeView)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/report/CodeView.js